



















import Vue from 'vue';
export default Vue.extend({
    data() {
        return {
            startTime: '2021/04/01 12:30',
            finishTime: '2021/04/01 15:30',
        };
    },
    props: {
        maintenanceLp: Boolean,
    },
});
